import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user.service';
import { MobileService } from '../services/mobile.service';

@Injectable()
export class AuthenticationGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    //private adalSvc: AdalService,
    private userService: UserService,
    private mobileService: MobileService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    //return true;

    let currentUser = this.userService.getUser();
    if (currentUser) {
      if (!this.userService.isTokenExpired()) {
        // Authenticated data-loading is deferred to app.component, gated on a *confirmed*
        // active subscription (and a real logged-in user), so a stale-but-not-yet-date-
        // expired token doesn't fire authenticated API calls before SubscriptionGuard has
        // had a chance to reject it.
        return true;
      }
    }
    
    this.userService.logoutOnTokenExp();
    const appPlatform = route.queryParams['appPlatform'];
    if (appPlatform) {
      this.mobileService.setPlatformType(appPlatform);
    }
    // not logged in so redirect to login page
    this.router.navigate(['/login']);

    return false;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    return this.canActivate(childRoute, state);
  }
}
